/* eslint-disable no-unused-expressions */
/* eslint-disable import/no-unresolved */
import theme from '@theme';
import React, { useCallback, useMemo, useState } from 'react';
import { ThemeProvider } from 'styled-components';

import { Season } from '@powdr/constants';
import { useScrollPosition } from '@powdr/hooks';
import { useStaticData } from '@powdr/web/src/hooks';

export const AppContext = React.createContext(null);

// eslint-disable-next-line react/prop-types
export const AppContextProvider = ({ children }) => {
  const { defaultSeason } = useStaticData();
  const [isMobile, setIsMobile] = useState(false);
  const [isWoodwardColorTakeover, setIsWoodwardColorTakeover] = useState(false);
  const [uiSeason, setUiSeason] = useState(defaultSeason);

  const [defaultTheme, setDefaultTheme] = useState({
    ...theme, ...theme.defaultTheme, ...theme.StaticTheme,
  });

  const handleTheme = useCallback((season, isWWTakeover) => {
    if (season === Season.SUMMER) {
      setDefaultTheme(
        {
          ...theme,
          ...(isWWTakeover) ? theme.wwAltTheme : theme.altTheme,
          ...theme.StaticTheme,
        },
      );
    } else {
      setDefaultTheme(
        {
          ...theme,
          ...(isWWTakeover) ? theme.wwDefaultTheme : theme.defaultTheme,
          ...theme.StaticTheme,
        },
      );
    }
  }, []);

  // add or remove no scroll class from body
  const toggleBodyScroll = useCallback((bool) => {
    if (bool) {
      document.body.classList.add('u-noscroll');
    } else {
      document.body.classList.remove('u-noscroll');
    }
  }, []);

  // HEADER CONTEXT
  // scroll position
  const scrollPosition = useScrollPosition();

  // season settings
  const [hasScrolledSeason, setHasScrolledSeason] = useState(false);
  const [seasonTabActive, setSeasonTabActive] = useState(false);

  const [inView, setInView] = useState('in-view');
  const [fullHeaderHeight, setFullHeaderHeight] = useState(0);

  // levels
  const [isCancelScroll, setIsCancelScroll] = useState(false);

  // Alert bar
  const [closedAlert, setClosedAlert] = useState(false);
  const [alertHeight, setAlertHeight] = useState();

  // Sticky Nav Second-level
  const [secondLevelNavHeight, setSecondLevelNavHeight] = useState();

  // Nav
  const [isMobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [isMobileThirdLevelOpen, setIsMobileThirdLevelOpen] = useState(false);

  // QR Query Card takeover handling
  const [isQrQueryCardPageActive, setQrQueryCardPageActive] = useState(false);
  const [singleItemView, setSingleItemView] = useState('');

  const setDrawerOpen = useCallback((bool) => {
    toggleBodyScroll(bool);
    setMobileDrawerOpen(bool);
    setIsMobileThirdLevelOpen(false);
  }, [toggleBodyScroll]);

  const toggleThirdLevel = useCallback((bool) => {
    setIsMobileThirdLevelOpen(bool);
  }, []);

  const context = useMemo(() => ({
    // APP
    svgs: theme.svgs,
    themeConfig: theme.config,
    defaultTheme,
    isMobile,
    setIsMobile,
    handleTheme,

    uiSeason,
    setUiSeason,

    hasScrolledSeason,
    setHasScrolledSeason,
    seasonTabActive,
    setSeasonTabActive,

    toggleBodyScroll,
    scrollPosition,
    inView,
    setInView,
    closedAlert,
    setClosedAlert,
    alertHeight,
    setAlertHeight,
    secondLevelNavHeight,
    setSecondLevelNavHeight,

    isWoodwardColorTakeover,
    setIsWoodwardColorTakeover,
    isCancelScroll,
    setIsCancelScroll,

    isMobileDrawerOpen,
    setDrawerOpen,
    isMobileThirdLevelOpen,
    toggleThirdLevel,
    fullHeaderHeight,
    setFullHeaderHeight,
    isQrQueryCardPageActive,
    setQrQueryCardPageActive,
    singleItemView,
    setSingleItemView,
  }), [
    // APP
    defaultTheme,
    isMobile,
    setIsMobile,
    handleTheme,

    uiSeason,
    setUiSeason,

    hasScrolledSeason,
    setHasScrolledSeason,
    seasonTabActive,
    setSeasonTabActive,

    toggleBodyScroll,
    scrollPosition,
    inView,
    setInView,
    closedAlert,
    setClosedAlert,
    alertHeight,
    setAlertHeight,
    secondLevelNavHeight,
    setSecondLevelNavHeight,

    isWoodwardColorTakeover,
    setIsWoodwardColorTakeover,
    isCancelScroll,
    setIsCancelScroll,

    isMobileDrawerOpen,
    setDrawerOpen,
    isMobileThirdLevelOpen,
    toggleThirdLevel,
    fullHeaderHeight,
    setFullHeaderHeight,
    isQrQueryCardPageActive,
    setQrQueryCardPageActive,
    singleItemView,
    setSingleItemView,
  ]);

  return (
    <AppContext.Provider value={context}>
      <ThemeProvider theme={defaultTheme}>
        {children}
      </ThemeProvider>
    </AppContext.Provider>
  );
};
